import { useEffect } from 'react';

import { AxiosResponse } from 'axios';
import { useNavigate } from 'react-router-dom';

import { ErrorBoundaries, PageInfo } from 'components';
import { Title } from 'pages/IncentiveCampaign/components';
import { IncentiveCampaignResultsContent } from 'pages/IncentiveCampaign/components/ResultsCampaignContent';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';
import { newRelicMonitoringService } from 'services';

import Styles from './IncentiveCampaignResults.styles';

export const IncentiveCampaignResults = () => {
  const navigate = useNavigate();
  const {
    isError: isErrorIncentiveCampaign,
    isResultActive,
    isNotFound,
    isError,
    isSuccess,
    isLoading,
    contentId,
    error: incentiveCampaignError,
  } = useLoyaltyIncentiveCampaign();

  useEffect(() => {
    if (!isLoading) {
      const error = incentiveCampaignError as AxiosResponse;
      newRelicMonitoringService.addPageAction('callback', {
        event_name: 'conteudo_campanha_de_incentivos_resultado',
        page_title: 'Resultado da Campanha de Incentivos',
        cd_detail: isSuccess ? 'sucesso' : `erro: ${error?.status ?? error ?? ''}`,
        user_not_found: isNotFound,
        result_active: isResultActive,
      });
    }

    if (isResultActive === false && !isLoading) {
      return navigate('/');
    }
    if (isNotFound && !isLoading && !!contentId) {
      return navigate(`/campanha-de-incentivos/${contentId}`);
    }
  }, [
    isResultActive,
    isNotFound,
    isError,
    isSuccess,
    incentiveCampaignError,
    isLoading,
    contentId,
    navigate,
  ]);

  if (isErrorIncentiveCampaign) {
    return (
      <ErrorBoundaries.ReloadPage
        title='Tivemos um problema para carregar a página de resultados.'
        data-autotagging-flora-section={document}
      />
    );
  }

  return (
    <Styles.Wrapper>
      <PageInfo
        breadcrumbs={[
          {
            text: 'Resultados da campanha',
            url: '',
          },
        ]}
      >
        <Styles.ContentWrapper>
          <Title />
          <IncentiveCampaignResultsContent />
        </Styles.ContentWrapper>
      </PageInfo>
    </Styles.Wrapper>
  );
};
